export default __webpack_public_path__ + "ArnaudBICHI.6f3997a.png";